import React from "react";
import "./StyleSheets.css";
import PropTypes from "prop-types";
import Icon from "../../Assets/IconLibrary/Icon";

export default class TabBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    changeTab = (activeTab) => {
        let {onChange} = this.props;
        onChange(activeTab)
    }


    render() {
        let {tabList, activeTab} = this.props;
        return (
            <div className="default-tab-bar">
                {
                    tabList.map((res, index) =>
                        <button className={res.Name === activeTab.Name ? "default-tab active" : "default-tab"}
                                key={index}
                                disabled={res.Disabled ? res.Disabled : false}
                                onClick={this.changeTab.bind(this, res)}>
                            {
                                res.Icon &&
                                <div className="default-tab-icon">
                                    <Icon name={res.Icon} size={14}/>
                                </div>
                            }
                            {res.Name}

                        </button>
                    )
                }
            </div>
        );
    }
}


TabBar.defaultProps = {
    tabList: [
        {
            Name: "Info",
            Icon: "info",
            IconType: "single",
            Disabled: false,
        }
    ],
    activeTab: {
        Name: "Info",
        Icon: "info",
        IconType: "single",
        Disabled: false,
    },
    width: "auto",
    height: "40px",
    padding: "40px",
    onChange: (activeTab) => alert("Active Tab => " + activeTab.Name)
}

TabBar.propTypes = {
    tabList: PropTypes.arrayOf(PropTypes.shape({
        Name: PropTypes.string.isRequired,
        Icon: PropTypes.string,
        IconType: PropTypes.oneOf(["single", "duo"]),
        Disabled: PropTypes.bool,
    })).isRequired,
    activeTab: PropTypes.arrayOf(PropTypes.shape({
        Name: PropTypes.string.isRequired,
        Icon: PropTypes.string,
        IconType: PropTypes.oneOf(["single", "duo"]),
        Disabled: PropTypes.bool,
    })).isRequired,
    width: PropTypes.string,
    height: PropTypes.string,
    padding: PropTypes.string.isRequired,
    onChange: PropTypes.func,
}